import Nullstack from 'nullstack';
export default function IconToolsKitchen2Off({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-tools-kitchen-2-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14.386 10.409c.53 -2.28 1.766 -4.692 4.614 -7.409v12m-4 0h-1c-.002 -.313 -.002 -.627 .002 -.941"
  }), "   ", Nullstack.element("path", {
    d: "M19 19v2h-1v-3"
  }), "   ", Nullstack.element("path", {
    d: "M8 8v13"
  }), "   ", Nullstack.element("path", {
    d: "M5 5v2a3 3 0 0 0 4.546 2.572m1.454 -2.572v-3"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}